export const props = {
  slideIsActive: {
    type: Boolean,
    default: false
  }
}
